import { makeVar } from '@apollo/client';

export const visibilityVar = makeVar(true);

const handleChangeVisibility = () => {
  if (document.visibilityState === 'visible') {
    visibilityVar(true);
  } else {
    visibilityVar(false);
  }
};

document.addEventListener('visibilitychange', handleChangeVisibility);
